export default {"src":"/_next/static/media/twitter.ffdbaa68.svg","height":28,"width":31,"blurWidth":0,"blurHeight":0};